import axios from 'axios'
import router from '@router'
import store from '@state/store'

export function getSavedState(key) {
  return JSON.parse(window.localStorage.getItem(key))
}

export function saveState(key, state) {
  window.localStorage.setItem(key, JSON.stringify(state))
}

export function setDefaultAuthHeaders(state) {
  axios.defaults.headers.common.Authorization = state.currentUserToken
    ? 'Bearer ' + state.currentUserToken.accessToken
    : 'UNAUTH'
}

export function setDefaultAxiosInterceptors() {
  // Add a response interceptor
  axios.interceptors.response.use(
    function(response) {
      //  Generate cancel token source
      let source = axios.CancelToken.source()

      // Set cancel token on this request
      response.cancelToken = source.token

      // Add to vuex to make cancellation available from anywhere
      store.commit('requestCancellation/ADD_CANCEL_TOKEN', source)

      return response
    },
    function(error) {
      // Do something with response error
      if (error.response && error.response.status === 401) {
        store.dispatch('auth/logOut')
        router.push('Login')
      }
    }
  )
}
